module.exports = __webpack_public_path__ + "static/media/zd.040bae53.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/zd.png
// module id = 58
// module chunks = 0